import { useState, useEffect } from 'react';
import ConfirmModal from '../../Common/ConfirmModal';
import CompanySelect from '../../Common/CompanySelect';
import { APIClient } from "../../helpers/api_helper";
import ProjectTypeSelect  from "../../Common/ProjectTypeSelect";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form,
  Input, InputNumber, Row, Space, Card
} from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loadProjects } from '../../slices/statics/projects/thunk';

const api = new APIClient();


const ProjectDetailsTab = ({projData}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);
  const [data, setData] = useState(null);
  const typeValue = useWatch('type', form);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    form.setFieldsValue(projData);
  }, [projData]);


  const handleConfirmedDelete = (projData) => {
    api.delete(`/api/projects/${projData.id}/`, {}, {successMsg: `Projekt uspešno izbrisan ${projData?.id}: ${projData?.title}`})
      .then(resp => {
        dispatch(loadProjects());
        navigate('/projects');
      })
      .catch(error => {
        console.error(error)
      })
  };

  const onSubmit = () => {
    setIsLoading(true)
    form
    .validateFields()
    .then((values) => {
      const payload = {
        ...values,
      };

      const isEdit = 'id' in projData && projData.id
      const apiCall = isEdit
      ? api.update(`/api/projects/${projData.id}/`, payload)
      : api.create('/api/projects/', payload, {successMsg: `Projekt uspešno ustvarjen ${payload.title}`});

      apiCall.then(resp => {
        dispatch(loadProjects());
        if (!isEdit){
          window.location.href = `/project/${resp.id}`;
        }
      }).catch(err => console.error('API error:', err));
    })
    .catch((info) => {
      console.error('Validate Failed:', info);
    })
    .finally(() => {
      setIsLoading(true)
    })
  };

  const isCreation = projData.id == null;

  return (
    <>
      <Card
        title='Glavno'
        extra={
          <Space>
            <Button disabled={isCreation} onClick={() => setShowDeletionConfirmModal(true)} danger><DeleteOutlined /></Button>
            <Button loading={isLoading} onClick={onSubmit} type="primary">Shrani</Button>
          </Space>
        }
      >
        <Form layout="vertical" form={form}>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="title"
                  label='Naslov'
                  rules={[]}
                  >
                  <Input placeholder={'naslov...'} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item name="internal_id" label="Interna oznaka - Šifrant">
                  <Input placeholder={'interna oznaka / Šifrant...'} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item name="year" label="Leto">
                  <InputNumber
                    placeholder={'leto...'}
                    min={2000}
                    max={2100}
                    controls={false}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item name="type" label="Tip">
                  <ProjectTypeSelect />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item name="customer" label="Stranka">
                  <CompanySelect />
                </Form.Item>
              </Col>
            </Row>
        </Form>

        <ConfirmModal
            textComponent={
                <p>
                  Ali ste prepričani, da želite <b>izbrisati projekt:<br/>
                  #{projData?.id} - {projData?.title}?</b>
                </p>
            }
            open={showDeletionConfirmModal}
            confirmBtnTitle='Izbriši'
            confirmBtnProps={{'danger': true}}
            onOk={() => handleConfirmedDelete(projData)}
            onCancel={() => {
            setShowDeletionConfirmModal(false);
            }}
        />
      </Card>
    </>
  );
};

export default ProjectDetailsTab;
